// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"33c64f9f","535":"9a3d05f8"}[chunkId] + ".chunk.js";
};